require('../blank.html');
require('npm/@homeaway/stab-calendar/release/stylesheets/stab-calendar-gt.css'); // 1 // was 4
require('npm/@homeaway/stab-datepicker/release/stylesheets/stab-datepicker-gt.css'); // 2 // was 5
require('npm/angular-ui-bootstrap/dist/ui-bootstrap-csp.css'); // 3 // was 2
require('npm/@homeaway/baseline/release/stylesheets/baseline-gt.css'); // 4 // was 1
require('npm/@homeaway/baseline/release/stylesheets/gt.css'); // 5 // was 3
require('npm/highlightjs/styles/default.css'); // 6 // was 6
require('npm/angular-material/angular-material.css'); // 7 // was 7
require('npm/toastr/build/toastr.css'); // 8 // was 8
require('npm/angular-loading-bar/build/loading-bar.css'); // 11 // was 11
require('npm/homeaway-bootstrap-3/release/stylesheets/gt.css'); // 13 // was  13

require('jquery');
require('jquery-validation');
require('lodash');
require('npm/homeaway-bootstrap-3/release/javascripts/bootstrap.js');
require('../styles/layout.scss');
require('npm/@fancyapps/fancybox/dist/jquery.fancybox.min.js');
require('npm/@fancyapps/fancybox/dist/jquery.fancybox.min.css');
require('../css/wpBootstrap0.css'); // Override all application specific stylesheet
require(['./wpBootstrap1'], function (wpBootstrap1) {
  $(document).ready(wpBootstrap1());
});


// WEBPACK FOOTER //
// ./app/scripts/wpBootstrap0.js